import { Form, Select, Tag } from 'antd';
import type { TCargoType } from 'api/swagger';
import { ALL_CARGO_TYPES, CARGO_TYPE_OPTIONS } from './constants';
import type { ICargoTypeSelectProps } from './types';
import { normalizeCargoTypes } from './utils';

export const CargoTypeSelect = (props: ICargoTypeSelectProps) => {
  const { onChange, className } = props;

  return (
    <Form.Item
      name='cargoTypes'
      className={className}
      getValueProps={(value?: TCargoType[]) => ({
        value: value?.length ? value : [ALL_CARGO_TYPES],
        allowClear: !!value?.length,
      })}
      normalize={normalizeCargoTypes}>
      <Select
        mode='multiple'
        optionFilterProp='label'
        maxTagCount='responsive'
        options={CARGO_TYPE_OPTIONS}
        tagRender={({ label, value, closable, onClose }) => (
          <Tag
            closable={value !== ALL_CARGO_TYPES && closable}
            onClose={onClose}
            onMouseDown={(event) => {
              event.preventDefault();
              event.stopPropagation();
            }}>
            {label}
          </Tag>
        )}
        onChange={onChange}
      />
    </Form.Item>
  );
};
